import {
  VERIFY_OTP_OPERATOR_START,
  VERIFY_OTP_OPERATOR_SUCCESS,
  VERIFY_OTP_OPERATOR_ERROR,
  VERIFIED_OTP_OPERATOR_START,
  VERIFIED_OTP_OPERATOR_SUCCESS,
  VERIFIED_OTP_OPERATOR_ERROR,
  VERIFIED_PARTNER_OTP_OPERATOR_START,
  VERIFIED_PARTNER_OTP_OPERATOR_SUCCESS,
  VERIFIED_PARTNER_OTP_OPERATOR_ERROR,
} from "../../../Constant";

const initialState = {
  loading: false,
  verifyData: {},
  verifiedData: {},
  verifiedPartnerData: {},
  errMsg: "",
};

export default function authReducer(state = { ...initialState }, action) {
  switch (action.type) {
    case VERIFY_OTP_OPERATOR_START:
      return {
        ...state,
        loading: true,
      };
    case VERIFY_OTP_OPERATOR_SUCCESS:
      return {
        ...state,
        verifyData: action.payload,
        loading: false,
      };
    case VERIFY_OTP_OPERATOR_ERROR:
      return {
        ...state,
        loading: false,
        errMsg: action.error.message,
      };
    case VERIFIED_OTP_OPERATOR_START:
      return {
        ...state,
        loading: true,
      };
    case VERIFIED_OTP_OPERATOR_SUCCESS:
      return {
        ...state,
        verifiedData: action.payload,
        loading: false,
      };
    case VERIFIED_OTP_OPERATOR_ERROR:
      return {
        ...state,
        loading: false,
        errMsg: action.error.message,
      };
    case VERIFIED_PARTNER_OTP_OPERATOR_START:
      return {
        ...state,
        loading: true,
      };
    case VERIFIED_PARTNER_OTP_OPERATOR_SUCCESS:
      return {
        ...state,
        verifiedPartnerData: action.payload,
        loading: false,
      };
    case VERIFIED_PARTNER_OTP_OPERATOR_ERROR:
      return {
        ...state,
        loading: false,
        errMsg: action.error.message,
      };
    default:
      return state;
  }
}
